export default __webpack_public_path__ + "9a141566271143fb388ba2f99351b3ca.png";